import React from 'react';
import PropTypes from 'prop-types';
import Link from "./Link";
import './column.scss'
import {useFlags} from "launchdarkly-react-client-sdk";
import { createTargetId } from '../../utils/util_functions.js';

export default function Column(props) {

  const flags = useFlags();

  return (
    <div className={`aps__column ${props.grid ? 'has-grid' : ''} ${props.classes}`}>
      {props.children}
      {props.links.map((item) => {
        if (!item.enabled) {
          return;
        }
        if (item.options?.attributes?.flag) {
          if (flags[item.options.attributes.flag] === false) {
            return;
          }
        }
        return (
          <Link
              testid={`header-nav-link-${createTargetId(item.title)}`}
              externalTarget={`header-nav-link-${createTargetId(item.title)}`}
              key={item.key}
              link={item.absolute}
              target={item.options?.attributes?.target ? item.options.attributes.target : ''}
              classes={item.options?.attributes?.class ? item.options.attributes.class.join(' ') : ''}
            >
            {item.options?.attributes?.thumbnail_url &&
              <img src={`//aps.autodesk.com/${item.options.attributes.thumbnail_url}`} alt={`Thumbnail image for ${item.title}`}/>
            }
            <span className={`title`}>{item.title}</span>
            {item.description &&
              <span className={`description`}>{item.description}</span>
            }
          </Link>
        );
      })}
    </div>
  );
};

Column.propTypes = {
  links: PropTypes.array,
  classes: PropTypes.string,
  grid: PropTypes.bool,
  children: PropTypes.node,
};

Column.defaultProps = {
  links: [],
  classes: '',
  grid: false,
};
